import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {NavItem} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-sidebar-item-button',
  templateUrl: 'sidebar-item-button.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['sidebar-item-button.component.scss']
})
export class SidebarItemButtonComponent implements OnInit, OnChanges {

  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Output() openMenu = new EventEmitter<NavItem>();

  isEnabled = true;
  showLabelTooltip: boolean;

  constructor(private permissionService: NgxPermissionsService) {
  }

  ngOnInit(): void {
    this.calcPermission();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.calcPermission();

    if (changes.collapsed) {
      this.showLabelTooltip = changes.collapsed.currentValue && this.item.tooltipEnabled;
    }
  }

  private calcPermission() {
    this.isEnabled = true;
    this.item.permissEnabled.forEach(p => {
      this.isEnabled = this.isEnabled && !!this.permissionService.getPermission(p);
    })
    // this.permissionService.hasPermission(this.item.permissEnabled).then((enabled) => {
    //   this.isEnabled = enabled;
    // });
  }
}
